import { QueryClient } from '@tanstack/react-query'

/** How long a cached entry survives without an observer (also the persister's maxAge). */
export const QUERY_CACHE_GC_TIME_MS = 1000 * 60 * 60 * 24

/**
 * One factory so the web app and the Capacitor build cache identically.
 * `staleTime` is deliberately non-zero: a phone that regains focus should not
 * refetch every screen it has ever rendered.
 */
export function makeQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 1000 * 60,
        gcTime: QUERY_CACHE_GC_TIME_MS,
        retry: 1,
        refetchOnWindowFocus: false,
      },
    },
  })
}
